enum Features {
  TREATMENT_PLAN = 'TreatmentPlan',
  TOXICOLOGY = 'Toxicology',
  BIDIRECTIONAL = 'BiDirectionalVisitNote',
  DOCUMENTS = 'Documents',
  OPEN_AI = 'OpenAi',
  DAYLY_DOWNLOAD = 'DailyDownload',
  CRISIS = 'Crisis',
  CRISIS_WEB_ALERTS = 'CrisisWebAlerts',
  AI_ASSIST = 'AiAssist',
  INTERVENTION = 'Intervention',
  MEDICAID = 'Medicaid',
}

export const featureLabels: { [key: string]: string } = {
  [Features.TREATMENT_PLAN]: 'Treatment Plan',
  [Features.TOXICOLOGY]: 'Toxicology',
  [Features.BIDIRECTIONAL]: 'Bidirectional',
  [Features.DOCUMENTS]: 'Documents',
  [Features.DAYLY_DOWNLOAD]: 'Daily Download',
  [Features.CRISIS]: 'Crisis',
  [Features.CRISIS_WEB_ALERTS]: 'Enable Crisis Web Alerts',
  [Features.OPEN_AI]: 'Mobile AI Assist',
  [Features.AI_ASSIST]: 'Web AI Assist',
  [Features.INTERVENTION]: 'Interventions',
  [Features.MEDICAID]: 'Medicaid Expansion',
};

export const featureList = [
  Features.TREATMENT_PLAN,
  Features.TOXICOLOGY,
  Features.BIDIRECTIONAL,
  Features.DOCUMENTS,
  Features.DAYLY_DOWNLOAD,
  Features.INTERVENTION,
  Features.CRISIS,
  Features.CRISIS_WEB_ALERTS,
  Features.OPEN_AI,
  Features.AI_ASSIST,
  Features.MEDICAID,
];

export default Features;
